import styles from "./StudyTogether.module.less";
import { useState, useEffect } from "react";
import { getWechatLink } from "@/api/payMember";
import { Toast } from "react-vant";
import { useLocation } from "react-router-dom";

function StudyTogetherWeb() {
  const [link, setLink] = useState("");
  const [codeImg, setCodeImg] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const order_sn = params.get("order_sn");
  const getLink = async () => {
    const res = await getWechatLink(order_sn);
    if (res.data?.link) {
      setLink(res.data.link);
    }
    if (res.data?.qr_image) {
      setCodeImg(res.data.qr_image);
    }
  };
  const handleClick = () => {
    Toast.info("正在跳转添加助教，请不要关闭页面");
    setTimeout(() => {
      window.location.href = link;
    }, 2000);
  };
  useEffect(() => {
    getLink();
  }, []);
  return (
    <div className={styles["study-container"]}>
      <div className={styles["back-wrapper"]}></div>
      <div className={styles["top"]}>
        <div className={styles["top-left"]}>
          <div className={styles["top-left-text"]}>欢迎扫码</div>
          <div className={styles["top-left-text"]}>
            添加口袋领航官方客服
          </div>
          <div className={styles["top-left-icon"]}>
            <div className={styles["left-circular"]}></div>
            <div className={styles["right-circular"]}></div>
          </div>
        </div>
        <img
          className={styles["top-right"]}
          src={require("@/images/mine/study-together/u_bao.png")}
        />
      </div>
      <div className={styles["center"]}>
        {link && (
          <>
            <div className={styles["newTitle"]}>
              请点击下方按钮，添加助教老师
            </div>
            <div className={styles["newButton"]} onClick={handleClick}>
              <div>点此按钮</div>
              <div>添加助教老师</div>
            </div>
            <div className={styles["newTitle"]}>如果上方按钮无法添加助教</div>
          </>
        )}
        <div className={styles["newTitle"]}>可以扫描二维码添加助教</div>
        {codeImg && <img className={styles["center-code"]} src={codeImg}></img>}
      </div>
      <div className={styles["bottom-box"]}>
        <div className={styles["bottom"]}>
          <div className={styles["bottom-item"]}>
            <img
              className={styles["item-icon"]}
              src={require("@/images/mine/study-together/icon_1.png")}
            />
            <div className={styles["item-text"]}>结伴学习</div>
            <div className={styles["item-text"]}>互动交流</div>
          </div>
          <div className={styles["bottom-item"]}>
            <img
              className={styles["item-icon"]}
              src={require("@/images/mine/study-together/icon_2.png")}
            />
            <div className={styles["item-text"]}>优先体验</div>
            <div className={styles["item-text"]}>最新功能</div>
          </div>
          <div className={styles["bottom-item"]}>
            <img
              className={styles["item-icon"]}
              src={require("@/images/mine/study-together/icon_3.png")}
            />
            <div className={styles["item-text"]}>优惠福利</div>
            <div className={styles["item-text"]}>快速获得</div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default StudyTogetherWeb;
